export default __webpack_public_path__ + "static/media/tutorial-step-0-sweepstakes.e25843de.png";